export const Hosting = () => {
    return (
        <svg className={"hosting-icon"} width="24.709" height="24" viewBox="0 0 24.709 24">
            <path
                d="M7.189-5.1a1.991,1.991,0,0,1-1.46-.6,1.983,1.983,0,0,1-.6-1.459V-9.8l5.491-4.877V-5.1Zm4.774,0V-10.59H23V-5.1H11.962Zm12.382,0V-16.364l-5.891-5.221,4.155-3.673,6.541,5.8a2.166,2.166,0,0,1,.511.708,2.051,2.051,0,0,1,.175.841V-7.161a1.992,1.992,0,0,1-.6,1.46,1.983,1.983,0,0,1-1.459.6H24.345ZM5.127-11.626v-6.268a2.164,2.164,0,0,1,.175-.856,1.906,1.906,0,0,1,.511-.7l10.3-9.127a1.745,1.745,0,0,1,.646-.4,2.248,2.248,0,0,1,.727-.12,2.242,2.242,0,0,1,.726.12,1.746,1.746,0,0,1,.646.4L21.6-26.135,5.127-11.626Z"
                transform="translate(-5.127 29.099)"
            />
        </svg>
    );
};
